import axios from 'axios';

const BASE_URL = '/api/preguntas-frecuentes';

export const fqasTemasService = {
  getTemas: async (empresaId, codigoProyecto) => {
    try {
      const response = await axios.get(`${BASE_URL}/temas`, {
        params: { proyectoId: codigoProyecto }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Themes:', error);
      return [];
    }
  }
};
